import _object_spread from "@swc/helpers/src/_object_spread.mjs";
export var BaseEnvironment;
(function(BaseEnvironment) {
    BaseEnvironment["RedirectUrlKey"] = "REDIRECT_URL_KEY";
})(BaseEnvironment || (BaseEnvironment = {}));
export var EnvironmentFromFile;
(function(EnvironmentFromFile) {
    EnvironmentFromFile["Adobe"] = "ADOBE_DTM";
    EnvironmentFromFile["LegacyAuthKey"] = "IDS_AUTH_KEY";
    EnvironmentFromFile["AuthKey"] = "AUTH0_AUTH_KEY";
    EnvironmentFromFile["ProfileServiceUrl"] = "PROFILE_SERVICE_URL";
    EnvironmentFromFile["StaticAssetsUrl"] = "STATIC_ASSETS_URL";
    EnvironmentFromFile["OrderServiceUrl"] = "ORDER_SERVICE_URL";
    EnvironmentFromFile["CinchcareServiceUrl"] = "CINCHCARE_SERVICE_URL";
    EnvironmentFromFile["DeliveryServiceURl"] = "DELIVERY_SERVICE_URL";
    EnvironmentFromFile["SearchServiceUrl"] = "SEARCH_SERVICE_URL";
    EnvironmentFromFile["SegmentKey"] = "SEGMENT_KEY";
    EnvironmentFromFile["IdentityServiceUrl"] = "IDENTITY_SERVICE_URL";
    EnvironmentFromFile["promoBannerName"] = "PROMO_BANNER_NAME";
    EnvironmentFromFile["cinchUrl"] = "CINCH_URL";
    EnvironmentFromFile["TrustpilotUrl"] = "TRUSTPILOT_URL";
    EnvironmentFromFile["StoryblokBFFComponent"] = "STORYBLOK_BFF_COMPONENT";
    EnvironmentFromFile["consumerValuationsServiceUrl"] = "CONSUMER_VALUATIONS_SERVICE_URL";
    EnvironmentFromFile["CinchChargeCardRequestUrl"] = "CINCH_CHARGE_CARD_REQUEST_URL";
    EnvironmentFromFile["CinchChargeCardRequestAPIKey"] = "CINCH_CHARGE_CARD_REQUEST_API_KEY";
    EnvironmentFromFile["ProductDetailServiceUrl"] = "PRODUCT_DETAIL_SERVICE_URL";
    EnvironmentFromFile["ReservationStatusUrl"] = "RESERVATION_STATUS_URL";
    EnvironmentFromFile["InventoryServiceHistoryUrl"] = "INVENTORY_SERVICE_HISTORY_URL";
    EnvironmentFromFile["IOSAppStoreUrl"] = "IOS_APP_STORE_URL";
    EnvironmentFromFile["AndroidAppStoreUrl"] = "ANDROID_APP_STORE_URL";
    EnvironmentFromFile["AdminFeeReturnToCheckout"] = "ADMIN_FEE_RETURN_TO_CHECKOUT";
    EnvironmentFromFile["AdminFeeValue"] = "ADMIN_FEE_VALUE";
    EnvironmentFromFile["AdminFeeLoyalty"] = "ADMIN_FEE_LOYALTY";
    EnvironmentFromFile["CheckoutReservationsDecoupling"] = "CHECKOUT_RESERVATIONS_DECOUPLING";
    EnvironmentFromFile["CheckoutReservationsDecouplingPhaseTwo"] = "CHECKOUT_RESERVATIONS_DECOUPLING_PHASE_TWO";
    EnvironmentFromFile["ReservationServiceUrl"] = "RESERVATION_SERVICE_URL";
    EnvironmentFromFile["DeliverySlotAvailabilityServiceUrl"] = "DELIVERY_SLOT_AVAILABILITY_SERVICE_URL";
    EnvironmentFromFile["FinanceApplicationServiceUrl"] = "FINANCE_APPLICATION_SERVICE_URL";
    EnvironmentFromFile["FinanceQuoteServiceUrl"] = "FINANCE_QUOTE_SERVICE_URL";
    EnvironmentFromFile["PaymentLinkServiceUrl"] = "PAYMENT_LINK_SERVICE_URL";
    EnvironmentFromFile["StripePublishableKey"] = "STRIPE_PUBLISHABLE_KEY";
    EnvironmentFromFile["GapServiceUrl"] = "GAP_SERVICE_URL";
    EnvironmentFromFile["EnableAmPmSlotsForDeliveries"] = "ENABLE_AM_PM_SLOTS_FOR_DELIVERIES";
    EnvironmentFromFile["ServicingAndWarrantyFlag"] = "SERVICING_AND_WARRANTY_FLAG";
    EnvironmentFromFile["DisableCinchCare"] = "DISABLE_CINCHCARE";
    EnvironmentFromFile["enableFomoMessaging"] = "ENABLE_FOMO_MESSAGING";
    EnvironmentFromFile["GapInsuranceFlag"] = "GAP_INSURANCE_FLAG";
    EnvironmentFromFile["CinchCareCopyFlag"] = "CINCHCARE_COPY_FLAG";
})(EnvironmentFromFile || (EnvironmentFromFile = {}));
export var EnvironmentFromProcess;
(function(EnvironmentFromProcess) {
    EnvironmentFromProcess["DataDogAPIKey"] = "DATADOG_API_KEY";
    EnvironmentFromProcess["DataDogClientId"] = "DATADOG_CLIENT_ID";
    EnvironmentFromProcess["DataDogRumApplicationId"] = "DATADOG_RUM_APPLICATION_ID";
    EnvironmentFromProcess["DataDogRumClientToken"] = "DATADOG_RUM_CLIENT_TOKEN";
    EnvironmentFromProcess["DataDogRumGlobalSampleRate"] = "DATADOG_RUM_GLOBAL_SAMPLE_RATE";
    EnvironmentFromProcess["DataDogServiceName"] = "DATADOG_SERVICE_NAME";
    EnvironmentFromProcess["BuildId"] = "BUILD_ID";
})(EnvironmentFromProcess || (EnvironmentFromProcess = {}));
export var Env = _object_spread({}, BaseEnvironment, EnvironmentFromFile, EnvironmentFromProcess);
